import { render, staticRenderFns } from "./ModalMotivoCancelamento.vue?vue&type=template&id=2487a759&"
import script from "./ModalMotivoCancelamento.vue?vue&type=script&lang=js&"
export * from "./ModalMotivoCancelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports